import React, { useMemo } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import FlexContainer from 'components/lib/ui/FlexContainer';
import DefaultButton from 'components/lib/ui/button/DefaultButton';

import type { BlockRenderer, CtaBlock } from 'common/lib/posts/types';
import { spacing } from 'common/lib/theme/dynamic';
import { useWhatsNew } from 'lib/hooks/useWhatsNew';

import routes from 'constants/routes';

const Root = styled(FlexContainer)`
  margin-top: ${spacing.xlarge};
  margin-bottom: ${spacing.xxlarge};
`;

const CtaBlockRenderer: BlockRenderer<CtaBlock> = ({ data: { id, text, href } }) => {
  const { push } = useHistory();
  const { dismissWhatsNew } = useWhatsNew();
  const onClick = useMemo(() => {
    if (href) {
      return () => window.open(href, '_blank');
    }
    if (id === 'navigateToReferrals') {
      return () => {
        dismissWhatsNew();
        push(routes.settings.referrals());
      };
    }
  }, [dismissWhatsNew, href, id, push]);

  if (!onClick) {
    return null;
  }

  return (
    <Root>
      <DefaultButton size="medium" onClick={onClick}>
        {text}
      </DefaultButton>
    </Root>
  );
};

export default CtaBlockRenderer;
